import { render, staticRenderFns } from "./MyCenter.vue?vue&type=template&id=4d1b9af6&scoped=true&"
import script from "./MyCenter.vue?vue&type=script&lang=js&"
export * from "./MyCenter.vue?vue&type=script&lang=js&"
import style0 from "./MyCenter.vue?vue&type=style&index=0&id=4d1b9af6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1b9af6",
  null
  
)

export default component.exports